












































import Vue from "vue"
import PPublicIconWithSpeechBalloonModal from "~/components/custom/speechBalloonModal/PPublicIconWithSpeechBalloonModal.vue"
import IconOnCircleBackground from "~/components/guideline/icon/IconOnCircleBackground.vue"

export default Vue.extend({
  components: {
    PPublicIconWithSpeechBalloonModal,
    IconOnCircleBackground,
  },
  props: {
    userProfileId: {
      type: String,
      default: null,
    },
    mainAccountImageUrl: {
      type: String,
      default: null,
    },
    isEditable: {
      type: Boolean,
      default: false,
    },
    isVisiblePublishSettingOnboardingModal: {
      type: Boolean,
      default: false,
    },
    publicStatus: {
      type: String,
      default: null,
    },
  },
  methods: {
    handleHideModal() {
      this.$emit("hide-publish-setting-onboarding-modal")
    },
    handleClickPublicStatusIcon() {
      this.$emit("click-public-status-icon")
    },
    handleClickSettingsIcon() {
      this.$emit("click-settings-icon")
    },
  },
})
